module.exports = __webpack_public_path__ + "static/img/home.af3a6e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/header/home.png
// module id = 036c
// module chunks = 7